import {ResearchLitElement, html, css, unsafeHTML} from '@core/research-lit-element';
import config from '../../config/config.js';

import {BdModal} from '@bog-design-system/bd-modal';
import {copyToClipboard} from '@bog-design-system/utils';
import '@bog-design-system/bd-snackbar';
import '@bog-design-system/bd-standard-button';
import '@bog-design-system/bd-font';
import '@bog-design-system/bd-action-button';
import '@bog-design-system/bd-list-item';
import '@bog-design-system/bd-date';
import '@bog-design-system/bd-chips';
import '@bog-design-system/bd-modal';
import '@bog-design-system/bd-video-player';

import {setMetaByProperty} from '../../common/research-meta-setter';
import '../../common/layout/research-section.js';
import '../../common/faq/research-faq.js';
import '../../common/research-card.js';
import '../../common/modals/research-info-modal.js';
import '../../skeleton/research-skeleton.js';
import './components/research-map.js';
import './components/research-stage-section.js';

class researchDetail extends ResearchLitElement {
    static get is() {
        return 'research-detail';
    }

    static get styles() {
        return css`
            .detail-section {
                display: flex;
                background-color: var(--color-pfm-home-background);
                padding-top: var(--space-48);
                padding-bottom: var(--space-96);
            }

            .details-container {
                display: flex;
                justify-content: center;
            }
    
            .details-wrapper {
                max-width: 1076px;
                width: -webkit-fill-available;
                display: flex;
                flex-direction: column;
                background-color: var(--color-invert-background-solid-40);
                border-radius: var(--border-radius-38);
                border: 1px solid var(--color-invert-component-tr-60);
            }

            .content-wrapper {
                padding: var(--space-32) var(--space-48);
                display: flex;
                flex-direction: column;
                gap: var(--space-32);
            }
          
            .large-padding {
                padding-bottom: var(--space-96);
            }

            .detail-header {
                --header-padding: 14px var(--space-24) 10px;
            }

            .detail-footer {
                --footer-padding: var(--space-24) var(--space-32);
                display: flex;
                justify-content: flex-end;
            }

            .action-button {
                --icon-color: var(--color-primary-solid-10);
                --icon-color-active: var(--color-primary-solid-10);
                --background-color: var(--color-primary-tr-70);
            }

            .details-head-block {
                display: flex;
                flex-direction: column;
                gap: var(--space-24);
                margin: 0 var(--space-16);
            }

            .badge-wrapper {
                display: flex;
                gap: var(--space-16);
                flex-wrap: wrap;
            }

            .gift-badge {
                --background-color: var(--color-secondary-solid-60);
                --text-color: var(--color-secondary-solid-10);
                --badge-icon-color: var(--color-secondary-solid-10);
                box-shadow: unset;
                cursor: default;
            }
          
            .badge {
                cursor: default;
            }

            .badge:hover,
            .badge:active {
                --chips-dark-70: var(--color-black-tr-80);
                --chips-dark-60: var(--color-black-tr-80);
            }

            .text-block {
                margin: 0 var(--space-16);
                display: flex;
                flex-direction: column;
                gap: var(--space-8);
            }

            .list-item {
                --li-min-height: 56px;
                --border-color: transparent;
                --padding-left: var(--space-16);
                --padding-right: var(--space-16);
                --li-section-padding: var(--space-8) 0;
                cursor: default;
            }

            .li-item {
                display: flex;
                flex-direction: column;
                gap: var(--space-4);
            }

            .li-description {
                display: flex;
                gap: var(--space-4);
            }

            .title h1,
            .description {
                text-align: center;
            }

            .title,
            .details-title,
            .text-block-title,
            .text-block-description,
            .methods-title,
            .method-card-title {
                color: var(--color-invert-component-tr-20);
            }

            .description {
                color: var(--color-invert-component-tr-30);
            }

            .map-wrapper {
                height: 373px;
                border-radius: var(--border-radius-38);
                overflow: hidden;
                background-color: var(--color-invert-background-solid-20);
            }

            .video-wrapper {
                position: relative;
                width: 470px;
                height: 265px;
            }

            .video-player {
                --icon-color: var(--color-white-solid-10);
                --icon-container-color: var(--color-primary-solid-10);
            }

            .video-image {
                width: inherit;
                height: inherit;
                object-fit: cover;
                border-radius: var(--space-36);
            }

            .video-image:hover {
                cursor: pointer;
                opacity: 0.5;
                transition: opacity 0.2s ease-in;
                background-color: var(--color-black-tr-60);
            }

            .faq-section {
                padding-bottom: var(--space-128);
            }

            .faq {
                --justify-title: center;
            }

            @media (max-width: 1024px) {
                .detail-section {
                    padding-bottom: var(--space-64);
                }

                .detail-footer {
                    --footer-padding: var(--space-16) var(--space-32);
                }
            }

            @media (max-width: 768px) {
                .detail-section {
                    padding-top: var(--space-32);
                }

                .content-wrapper {
                    padding: var(--space-32) var(--space-40);
                }

                .large-padding {
                    padding-bottom: var(--space-64);
                }

                .details-head-block {
                    margin: 0;
                }

                .text-block {
                    margin: 0;
                }

                .list-item {
                    --padding-left: 0;
                    --padding-right: 0;
                }

                .title h1,
                .description {
                    text-align: left;
                }
                
                .faq-section {
                    padding-bottom: var(--space-96);
                }
            }

            @media (max-width: 600px) {
                .detail-section {
                    padding-top: var(--space-24);
                    padding-bottom: var(--space-48);
                    --border-space: 0;
                }

                .content-wrapper {
                    padding: var(--space-32) var(--space-24);
                }

                .large-padding {
                    padding-bottom: var(--space-48);
                }
                
                .share-btn {
                  --padding: var(--space-8) 0 var(--space-8) var(--space-8);
                }

                .badge-wrapper {
                    flex-wrap: wrap;
                    gap: var(--space-8);
                }

                .video-wrapper {
                    position: relative;
                    width: 100%;
                    height: 182px;
                }

                .video-image {
                    border-radius: var(--border-radius-38);
                }

                .map-wrapper {
                    height: 182px;
                }

                #map {
                    --height: 182px;
                }
                
                .detail-footer-btn {
                    width: 100%;
                }

                .faq-section {
                    padding-top: var(--space-32);
                    padding-bottom: var(--space-64);
                    --border-space: var(--space-16);
                }

                .faq {
                    --faq-padding: var(--space-24) var(--space-16);
                    --title-font-size: var(--space-24);
                }
            }
        `;
    }

    render() {
        return html`
            ${this.data?.details && this.data.researchDetail?.title ?
                html`
                      <research-section class="detail-section">
                          <div class="details-container">
                          <div class="details-wrapper">
                              <bd-modal-header class="detail-header" divider>
                                  <bd-action-button
                                      slot="title"
                                      class="action-button"
                                      type="basic-icon"
                                      icon="bd:chevron_left"
                                      small
                                      text-centered
                                      hide-description-tooltip
                                      header="${this.data.details?.backBtnTitle}"
                                      href="${this.data.details?.backBtnUrl?.link}"
                                      target="${this.data.details?.backBtnUrl?.target}"
                                      max-lines="2"
                                      direction="horizontal"
                                  >
                                  </bd-action-button>
                                  <bd-standard-button
                                      class="share-btn"
                                      type="text-low"
                                      prefix-icon="bd:copy"
                                      slot="close"
                                      dropdownicon="bd:chevron_down"
                                      @click="${this._copy}"
                                  >
                                      ${!this._isMobile ? this.data.details?.shareBtnTitle : ''}
                                  </bd-standard-button>
                              </bd-modal-header>
                              <div class="content-wrapper ${!this.data.researchDetail.details?.videoUrl &&
                              !this.data.researchDetail.details?.locationText &&
                              !this.data.researchDetail.details?.transportText ? 'large-padding' : ''}">
                                  <div class="details-head-block">
                                      <bd-font class="details-title" type="h4">
                                          <h1>${this.data.researchDetail.title}</h1>
                                      </bd-font>
                                      <div class="badge-wrapper">
                                          ${this.getBadge('bd:loyalty', this.data.details?.giftText, true)}
                                          ${this.getBadge('bd:time_clock', this.data.researchDetail?.duration)}
                                          ${this.getBadge('bd:banking_service', this.data.researchDetail?.location?.value?.title)}
                                          ${this.getBadge('bd:banking_internet',
        this.data.researchDetail?.device?.value?.text || this.data.researchDetail?.device?.value?.title)}
                                          ${this.getBadge('', this.data.researchDetail?.method?.value?.title)}
                                          ${this.getBadge('', this.data.researchDetail?.additionalBadge)}
                                      </div>
                                  </div>
                                  ${this.data.researchDetail.details?.fullDescription ?
                                      this.getTextBlock(
                                            this.data.details?.descriptionLabel,
                                            this.data.researchDetail.details.fullDescription,
                                            true
                                        ) :
                                      this.data.researchDetail.description ?
                                      this.getTextBlock(
                                            this.data.details?.descriptionLabel,
                                            this.data.researchDetail.description
                                        ) :
                                      ''}
                                  ${this.data.researchDetail.details?.devicesText ?
                                      this.getTextBlock(
                                            this.data.details?.devicesLabel,
                                            this.data.researchDetail.details.devicesText,
                                            true
                                        ) :
                                      ''}
                                  ${this.data.researchDetail.startDate ?
                                      html`
                                            <bd-list-item class="list-item" static>
                                                <div class="li-item" slot="center">
                                                    <bd-font type="subtitle" class="li-title">
                                                        ${this.data.details?.datesLabel}
                                                    </bd-font>
                                                    <bd-font type="body1" class="li-description">
                                                        <bd-date value=${this.data.researchDetail.startDate}></bd-date> -
                                                        <bd-date value=${this.data.researchDetail.finishDate}></bd-date>
                                                    </bd-font>
                                                </div>
                                            </bd-list-item>
                                        ` :
                                      ''}
                                  ${this.data.researchDetail.details?.additionalText ?
                                      this.getTextBlock(
                                            this.data.researchDetail.details?.additionalTitle,
                                            this.data.researchDetail.details.additionalText,
                                            true
                                        ) :
                                      ''}
                                  ${this.data.researchDetail.details?.videoUrl ?
                                      this.getVideoItem(this.data.researchDetail.details) :
                                      ''}
                                  ${this.data.researchDetail.details?.locationText ?
                                      this.getTextBlock(
                                            this.data.details?.locationLabel,
                                            this.data.researchDetail.details.locationText,
                                            true
                                        ) :
                                      ''}
                                  ${this.data.researchDetail.details?.locationText ?
                                      html`
                                            <div class="map-wrapper">
                                                <research-map
                                                    id="map"
                                                    .data="${this.data?.mapContent}"
                                                    .searchResult="${[this.locationCoords]}"
                                                    .selectedCoords="${this.locationCoords}"
                                                ></research-map>
                                            </div>
                                        ` :
                                      ''}
                                  ${this.data.researchDetail.details?.transportText ?
                                      this.getTextBlock(
                                            this.data.details?.transportLabel,
                                            this.data.researchDetail.details.transportText,
                                            true
                                        ) :
                                      ''}
                              </div>
                              ${this.data?.researchDetail?.registration ? html`
                              <bd-modal-footer class="detail-footer" divider>
                                  <bd-standard-button
                                      type="primary"
                                      class="detail-footer-btn"
                                      @click="${this.openModal}"
                                  >
                                      ${this.data.details.registrationBtnTitle}
                                  </bd-standard-button>
                              </bd-modal-footer>
                              ` : ''}
                          </div>
                          </div>
                      </research-section>
                  ` :
                ''}

            ${this.data?.stageBanner?.title ? html`
            <research-stage-section .data="${this.data.stageBanner}"
            ></research-stage-section>
            ` : '' }
            
            ${this.data.faq?.faqTitle && this.data.faq.faq?.length > 0 ?
                html`
                      <research-section class="faq-section">
                          <research-faq class="faq" stroke title-type="h2" .data="${this.data.faq}"> </research-faq>
                      </research-section>
                  ` :
                ``}

            <bd-snackbar id="snackbar">
                ${this.data?.copyBtnSuccessMsg}
            </bd-snackbar>
        `;
    }

    getTextBlock(title, text, htmlText = false) {
        return html`
            <div class="text-block">
                <bd-font class="text-block-title" type="subtitle">
                    <h4>${title}</h4>
                </bd-font>
                <bd-font class="text-block-description" type="body1">
                    <span>${htmlText ? unsafeHTML(text) : text}</span>
                </bd-font>
            </div>
        `;
    }

    getBadge(icon, text, gift = false) {
        if (!text) return '';
        return html`
            ${gift ?
                html`
                      <bd-badge-overline class="gift-badge">
                          <bd-icon icon="${icon}"></bd-icon>
                          <bd-font type="overline2-ultrabold">
                              <span>${text}</span>
                          </bd-font>
                      </bd-badge-overline>
                  ` :
                html`
                      <bd-chips class="badge" size="medium" label="${text}" static static-color>
                          ${icon ? html`
                          <bd-icon icon="${icon}" slot="icon"> </bd-icon>
                          ` : ''}
                      </bd-chips>
                  `}
        `;
    }

    getVideoItem(data) {
        return html`
            <div class="video-wrapper">
                <img class="video-image" src="${data.imageUrl.url}" @click=${this._playVideo} />
                <bd-video-player class="video-player" id="video" video-link="${data.videoUrl}">
                </bd-video-player>
            </div>
        `;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
            locationCoords: {
                type: Object,
            },
            isLoading: {
                type: Boolean,
            },
        };
    }

    constructor() {
        super();
        this.data = {};
        this.isLoading = true;

        this.initLocations();

        this._isMobile = window.matchMedia(`(max-width: 600px)`).matches;
        this._isTablet = window.matchMedia(`(max-width: 768px)`).matches;
        this._isLaptop = window.matchMedia(`(max-width: 1024px)`).matches;
    }

    connectedCallback() {
        super.connectedCallback();
        if (!this.params?.length) {
            window.history.pushState(null, null, `${window.location.origin}/${this.lang}/research/404`);
            window.dispatchEvent(new PopStateEvent('popstate'));
        }

        this.locationCoords = {
            latitude: '41.736310',
            longitude: '44.748260',
        };

        const {$ref, $id} = this.ref;
        this.apiCall(`catalog/get-details/${$ref}/${$id}/${this.params[0]}`)
            .then((res) => {
                this.data = res.json.data;

                document.title = this.data.researchDetail?.title;
                setMetaByProperty('og:title', this.data.researchDetail?.title);
                setMetaByProperty('og:description', this.data.researchDetail?.description);
                if (this.data.researchDetail?.image) {
                    setMetaByProperty('og:image', `${config.ramadUrl}${this.data.researchDetail.image.url}`);
                }
                setMetaByProperty('og:url', window.location.href);
            })
            .catch((err) => console.error(err));
    }

    _copy() {
        copyToClipboard(window.location.href);
        this._showSuccess();
    }

    _showSuccess() {
        this._snackbar.open('', {
            placement: 'bottomLeft',
            dismissTime: 2000,
        });
    }

    get _snackbar() {
        return this.shadowRoot.getElementById('snackbar');
    }

    _playVideo() {
        this.shadowRoot.getElementById('video').showPlayer();
    }

    openModal() {
        const options = {
            element: this._modalContent(),
            sticky: false,
            beforeClose: null,
        };
        BdModal.open(options).catch(() => {});
    }

    _closeModal() {
        BdModal.close();
    }

    _modalContent() {
        return html`
            <research-info-modal
                .data="${this.data?.infoModal}"
                .registrationUrl="${this.data?.researchDetail?.registration}"
                @close-info-modal="${this._closeModal}"
            ></research-info-modal>
        `;
    }
}

window.customElements.define(researchDetail.is, researchDetail);
